exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main{margin-left:230px;background-color:#e9e9e9;min-height:100vh}@media screen and (max-width:768px){.app-main{margin-left:0}}.lp-loading{position:fixed;top:0;left:0;right:0;bottom:0;z-index:10000;background:rgba(0,0,0,.3);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.lp-loading i{position:fixed;top:50%}.app-content{padding:20px}.lp-main-outsider{position:fixed;top:0;left:0;right:0;bottom:0;z-index:120;background:rgba(0,0,0,.3)}.container{width:100%}", ""]);

// exports
